module.exports = __webpack_public_path__ + "static/media/how-it-works-leasing-1.ecbcc636.svg";